module.exports = __webpack_public_path__ + "static/img/Doit-03.99af5da.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Doit-03.png
// module id = ygBY
// module chunks = 0